import React, { Component } from 'react';
import mailImg from 'images/mail.png'
import {withRouter} from 'react-router-dom';
import HttpClient from 'services/HttpClient';
import {inject} from 'mobx-react';
const RECOVERY_TOKEN_CREATE = '/api/v1/passwords_recovery';

@withRouter
@inject('alertStore')
export default class EmailConfirmation extends Component {

  resentEmail = () => {
    new HttpClient().post(RECOVERY_TOKEN_CREATE, {email: this.props.match.params.email}).then(() => {
      this.handleResponse();
    }).catch(() => {
      this.handleResponse();
    })
  };

  handleResponse(){
    this.props.alertStore.success('We have sent another confirmation email to you. Please check your email.')
  }

  render() {
    return(
      <section className="section-center">
        <div className="section-center-wrapper">
          <h3 className="title">A link with instructions
            has been sent to {this.props.match.params.email}</h3>
          <img src={mailImg} alt="Not found"/>
          <p className="desc">If you can’t find an email, check your spam folder or click the link below</p>
          <p className="highlight button-set"
             onClick={this.resentEmail}>Resend confirmation email</p>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/blocks/EmailConfirmation.js